import { Center, Spinner, Flex, Heading, Container } from '@chakra-ui/react';

import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Tour from 'reactour';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as wActions from '../../redux/wallet/actionCreators';
import * as abActions from '../../redux/addressbook/actionCreators';
import { guideCompleted } from '../../redux/common/actionCreators';
import PageBody from '../../components/pageBody/pageBody';
import TransactionList from '../../components/transactionList/transactionList';
import Footer from '../../components/footer/footer';

type TransactionProps = {
    wallet?: any;
    loading: boolean;
    walletActions?: any;
    addressBookActions?: any;
    addresses: Array<string>;
    commonActions?: any;
    tourCompleted: boolean;
    transactions: Array<any>;
    pendingTransactions: Array<any>;
};

const Transaction = (props: TransactionProps) => {
    const history = useHistory();
    const wallet = props.wallet;
    const loading = props.loading;
    const [isTourOpen, setIsTourOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!wallet) {
            history.replace('/wallet/create');
        }
    }, [wallet]);

    const handleTxSelect = useCallback(tx => {
        history.push(`/tx/${tx.hash}`);
    }, []);

    if (loading) {
        return (
            <PageBody>
                <Center>
                    <Spinner color='blue.500' size='xl' />
                </Center>
            </PageBody>
        );
    }

    return (
        <Container maxW='6xl' h='100%'>
            <Flex direction='column' h='100%'>
                <Flex
                    flex='0.5'
                    justifyContent='center'
                    alignItems='center'
                    direction='column'
                    id='balance'
                >
                    <Heading>Lista transazioni</Heading>
                </Flex>
                <Flex flex='3' direction='column' overflow='scroll'>
                    <TransactionList
                        transactions={props.pendingTransactions}
                        onSelect={handleTxSelect}
                        caption='Lista transazioni in corso'
                    />
                    <TransactionList
                        transactions={props.transactions}
                        onSelect={handleTxSelect}
                        caption='Lista transazioni completate'
                    />
                </Flex>
                <Footer />
            </Flex>
        </Container>
    );
};

const mapStateToProps = ({ wallet, addressbook, common, transaction }: any) => {
    return {
        wallet: wallet.wallet,
        loading: wallet.loading,
        addresses: addressbook.addresses,
        tourCompleted: common.guide.wallet,
        transactions: Object.values(transaction.transactions),
        pendingTransactions: Object.values(transaction.pendingTransactions),
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    walletActions: bindActionCreators(wActions, dispatch),
    addressBookActions: bindActionCreators(abActions, dispatch),
    commonActions: {
        guideCompleted: (guideName: string) =>
            dispatch(guideCompleted(guideName)),
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
